(function () {
	"use strict";
	var $ = avm.require("jquery");

	//$_ refers to jQuery added into Text file
	if (typeof $_ !== 'undefined') {
		$ = $_;
	}

	// Language in this array: load/submit use current path (localized). Not in array: use root path, English content.
	const lang = avastGlobals.web.language.toLowerCase();
	const locale = avastGlobals.web.locale.toLowerCase();
	const localizedLanguages = ['en', 'cs', 'da', 'es', 'it', 'nl', 'no', 'sv', 'de', 'fr', 'pl', 'ja'];
	const localizedLocales = ['pt-br', 'ru-ru'];
	const isLocalized = localizedLanguages.includes(lang) || localizedLocales.includes(locale);
	const formNamePrefix = document.location.hostname === 'web-preview.svc.int.avast.com' ? '/www.avast.com/' : '/';

	$(document).ready(function() {
		$("#business-support-contact-form").load((isLocalized ? "" : formNamePrefix) + "business-support-contact-form", function() {
			initAvastForm(isLocalized ? "" : "english");

			//DS TWEAKS
			[].forEach.call(
				document.querySelectorAll(".form-group input:not([type=submit]), .form-group textarea"),
				function(el) {
					el.classList.add("form-control");
				}
			);
			[].forEach.call(
				document.querySelectorAll(".form-group select"),
				function(el) {
					el.classList.add("custom-select");
				}
			);
			[].forEach.call(
				document.querySelectorAll(".form-group .button"),
				function(el) {
					el.classList.add("btn");
					el.classList.add("btn-primary");
				}
			);


			var labels = document.querySelectorAll(".form-group .label");
			var i = labels.length;

			while (i--) {
				var label = labels.item(i);
				var text = label.textContent;
				var isRequired = label.parentNode.classList.contains("required");
				var nextElement = label.nextElementSibling.firstChild;

				if (nextElement) {
						//Aria
						nextElement.setAttribute("aria-label", text.replace(':', ''));
						if (isRequired) {
								nextElement.setAttribute("aria-required", true);
						}

						//Placeholder
					if (nextElement.tagName == 'SELECT') {
						nextElement.options[0].text = text;
					} else {
						nextElement.setAttribute("placeholder", text);
					}

					label.parentNode.removeChild(label);
				}
			}
		});
	});

})();
